/**
 * Helpers de UI para pedidos — copia del desktop
 * (`apps/desktop/src/renderer/src/lib/orders.ts`) para mantener labels
 * y colores consistentes en ambos clientes.
 */

import type { OrderOrigin, OrderStatus } from '@atreus/core';

export const orderStatusLabels: Record<OrderStatus, string> = {
  draft: 'Borrador',
  placed: 'Confirmado',
  preparing: 'Preparando',
  ready: 'Listo',
  delivered: 'Entregado',
  paid: 'Pagado',
  cancelled: 'Cancelado',
};

export const orderOriginLabels: Record<OrderOrigin, string> = {
  table: 'Mesa',
  delivery: 'Domicilio',
  counter: 'Mostrador',
};

export const orderStatusChipClass = (status: OrderStatus): string => {
  switch (status) {
    case 'draft':
      return 'border-border bg-surface-muted text-fg-muted';
    case 'placed':
      return 'border-accent/40 bg-accent/10 text-accent';
    case 'preparing':
    case 'ready':
      return 'border-warning/40 bg-warning/10 text-warning';
    case 'delivered':
    case 'paid':
      return 'border-success/40 bg-success/10 text-success';
    case 'cancelled':
      return 'border-danger/40 bg-danger/10 text-danger';
  }
};
